import React from 'react'
import Lottie from 'lottie-react';
import loadingDark from './pingiloading.json';

import LoadingStyles from './styles/loading.module.scss';

const Loading = () => {
    return <Lottie animationData={loadingDark} className={LoadingStyles.loading}/>
}

export async function getStaticProps() {
    return {
        props: {
            layout: 'clear'
        }
    }
}

export default Loading